import { render, staticRenderFns } from "./RolesProfiles.vue?vue&type=template&id=483364d2&scoped=true"
import script from "./RolesProfiles.vue?vue&type=script&lang=js"
export * from "./RolesProfiles.vue?vue&type=script&lang=js"
import style0 from "./RolesProfiles.vue?vue&type=style&index=0&id=483364d2&prod&scoped=true&lang=css"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483364d2",
  null
  
)

export default component.exports